module.exports = __webpack_public_path__ + "img/antes_despues_319.74a3578b.png";